import React, { useEffect, useState } from "react";
import { Drawer } from "rsuite";
import Autocomplete from "@mui/material/Autocomplete";
import MenuItem from "@mui/material/MenuItem";
import { TextField } from "@mui/material";
import Modal from "@mui/material/Modal";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { ToastContainer, toast } from "react-toastify";
import BaseUrl from "../BaseUrl";
import axios from "axios";
import Loader from "../Loader";
import nodata from "../Images/ImageToStl.com_noschedules.avif";

const timeList = [
  "1:00 AM",
  "2:00 AM",
  "3:00 AM",
  "4:00 AM",
  "5:00 AM",
  "6:00 AM",
  "7:00 AM",
  "8:00 AM",
  "9:00 AM",
  "10:00 AM",
  "11:00 AM",
  "12:00 AM",
  "1:00 PM",
  "2:00 PM",
  "3:00 PM",
  "4:00 PM",
  "5:00 PM",
  "6:00 PM",
  "7:00 PM",
  "8:00 PM",
  "9:00 PM",
  "10:00 PM",
  "11:00 PM",
  "12:00 PM",
];

const timezoneArr = [
  "(UTC-12:00) International Date Line West",
  "(UTC-11:00) Coordinated Universal Time-11",
  "(UTC-10:00) Hawaii",
  "(UTC-09:00) Alaska",
  "(UTC-08:00) Baja California",
  "(UTC-08:00) Pacific Time (US and Canada)",
  "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
  "(UTC-07:00) Arizona",
  "(UTC-07:00) Mountain Time (US and Canada)",
  "(UTC-06:00) Central America",
  "(UTC-06:00) Central Time (US and Canada)",
  "(UTC-06:00) Saskatchewan",
  "(UTC-06:00) Guadalajara, Mexico City, Monterey",
  "(UTC-05:00) Bogota, Lima, Quito",
  "(UTC-05:00) Indiana (East)",
  "(UTC-05:00) Eastern Time (US and Canada)",
  "(UTC-04:30) Caracas",
  "(UTC-04:00) Atlantic Time (Canada)",
  "(UTC-04:00) Asuncion",
  "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
  "(UTC-04:00) Cuiaba",
  "(UTC-04:00) Santiago",
  "(UTC-03:30) Newfoundland",
  "(UTC-03:00) Brasilia",
  "(UTC-03:00) Greenland",
  "(UTC-03:00) Cayenne, Fortaleza",
  "(UTC-03:00) Buenos Aires",
  "(UTC-03:00) Montevideo",
  "(UTC-02:00) Coordinated Universal Time-2",
  "(UTC-01:00) Cape Verde",
  "(UTC-01:00) Azores",
  "(UTC+00:00) Casablanca",
  "(UTC+00:00) Monrovia, Reykjavik",
  "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
  "(UTC+00:00) Coordinated Universal Time",
  "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
  "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
  "(UTC+01:00) West Central Africa",
  "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
  "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
  "(UTC+01:00) Windhoek",
  "(UTC+02:00) Athens, Bucharest, Istanbul",
  "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
  "(UTC+02:00) Cairo",
  "(UTC+02:00) Damascus",
  "(UTC+02:00) Amman",
  "(UTC+02:00) Harare, Pretoria",
  "(UTC+02:00) Jerusalem",
  "(UTC+02:00) Beirut",
  "(UTC+03:00) Baghdad",
  "(UTC+03:00) Minsk",
  "(UTC+03:00) Kuwait, Riyadh",
  "(UTC+03:00) Nairobi",
  "(UTC+03:30) Tehran",
  "(UTC+04:00) Moscow, St. Petersburg, Volgograd",
  "(UTC+04:00) Tbilisi",
  "(UTC+04:00) Yerevan",
  "(UTC+04:00) Abu Dhabi, Muscat",
  "(UTC+04:00) Baku",
  "(UTC+04:00) Port Louis",
  "(UTC+04:30) Kabul",
  "(UTC+05:00) Tashkent",
  "(UTC+05:00) Islamabad, Karachi",
  "(UTC+05:30) Sri Jayewardenepura Kotte",
  "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
  "(UTC+05:45) Kathmandu",
  "(UTC+06:00) Astana",
  "(UTC+06:00) Dhaka",
  "(UTC+06:00) Yekaterinburg",
  "(UTC+06:30) Yangon",
  "(UTC+07:00) Bangkok, Hanoi, Jakarta",
  "(UTC+07:00) Novosibirsk",
  "(UTC+08:00) Krasnoyarsk",
  "(UTC+08:00) Ulaanbaatar",
  "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
  "(UTC+08:00) Perth",
  "(UTC+08:00) Kuala Lumpur, Singapore",
  "(UTC+08:00) Taipei",
  "(UTC+09:00) Irkutsk",
  "(UTC+09:00) Seoul",
  "(UTC+09:00) Osaka, Sapporo, Tokyo",
  "(UTC+09:30) Darwin",
  "(UTC+09:30) Adelaide",
  "(UTC+10:00) Hobart",
  "(UTC+10:00) Yakutsk",
  "(UTC+10:00) Brisbane",
  "(UTC+10:00) Guam, Port Moresby",
  "(UTC+10:00) Canberra, Melbourne, Sydney",
  "(UTC+11:00) Vladivostok",
  "(UTC+11:00) Solomon Islands, New Caledonia",
  "(UTC+12:00) Coordinated Universal Time+12",
  "(UTC+12:00) Fiji, Marshall Islands",
  "(UTC+12:00) Magadan",
  "(UTC+12:00) Auckland, Wellington",
  "(UTC+13:00) Nuku'alofa",
  "(UTC+13:00) Samoa",
];

export const CreateScheduleDrawer = ({
  openCreateScheduleDrawer,
  setterFun,
  selectedScheduleSetterFun,
  selectedScheduleData,
}) => {
  const [open3, setOpen3] = useState(true);
  const [shceduleName, setScheduleName] = useState("");
  const [countryTimeSchedule, setCountryTimeSchdule] = useState(null);
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [daylistArr, setDayListArr] = useState([
    {
      Day: "Sunday",
      Active: false,
      StartHour: "9:00 AM",
      EndHour: "6:00 PM",
      StartMinute: 0,
      EndMinute: 0,
    },
    {
      Day: "Monday",
      Active: true,
      StartHour: "9:00 AM",
      EndHour: "6:00 PM",
      StartMinute: 0,
      EndMinute: 0,
    },
    {
      Day: "Tuesday",
      Active: true,
      StartHour: "9:00 AM",
      EndHour: "6:00 PM",
      StartMinute: 0,
      EndMinute: 0,
    },
    {
      Day: "Wednesday",
      Active: true,
      StartHour: "9:00 AM",
      EndHour: "6:00 PM",
      StartMinute: 0,
      EndMinute: 0,
    },
    {
      Day: "Thursday",
      Active: true,
      StartHour: "9:00 AM",
      EndHour: "6:00 PM",
      StartMinute: 0,
      EndMinute: 0,
    },
    {
      Day: "Friday",
      Active: true,
      StartHour: "9:00 AM",
      EndHour: "6:00 PM",
      StartMinute: 0,
      EndMinute: 0,
    },
    {
      Day: "Saturday",
      Active: false,
      StartHour: "9:00 AM",
      EndHour: "6:00 PM",
      StartMinute: 0,
      EndMinute: 0,
    },
  ]);

  const [scheduleData, setScheduleData] = useState([]);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [newSchedule, setNewSchedule] = useState(false);
  const [defaultUi, setDefaultUi] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleChange9 = (event, newValue) => {
    setCountryTimeSchdule(newValue);
  };

  function convertTo24HourFormat(time) {
    const [timePart, ampm] = time.split(" ");
    const [hours, minutes] = timePart.split(":");
    let hour = parseInt(hours, 10);

    if (ampm === "PM" && hour < 12) {
      hour += 12;
    } else if (ampm === "AM" && hour === 12) {
      hour = 0;
    }

    return hour.toString().padStart(2, "0");
  }

  function convertTo12HourFormat(hour) {
    // Check if the input is a valid number between 0 and 23
    if (typeof hour !== "number" || hour < 0 || hour > 23) {
      return "Invalid input";
    }

    // Convert 24-hour format to 12-hour format
    if (hour === 0) {
      return "12:00 AM";
    } else if (hour < 12) {
      return hour + ":00 AM";
    } else if (hour === 12) {
      return "12:00 PM";
    } else {
      return hour - 12 + ":00 PM";
    }
  }

  function createSchedule() {
    setIsLoading(true);
    const modifiedData = daylistArr.map((item) => ({
      ...item,
      StartHour: parseInt(convertTo24HourFormat(item.StartHour)),
      EndHour: parseInt(convertTo24HourFormat(item.EndHour)),
    }));
    let schedData = {
      Name: shceduleName,
      TimeZone: countryTimeSchedule,
      Day: modifiedData,
    };
    axios
      .post(
        `${BaseUrl.baseurl}/email-marketing/automation/create-schedule/${
          userDetails && userDetails.details._id
        }`,
        { data: JSON.stringify(schedData) },
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          getShceduleData();
          setIsLoading(false);
          setDefaultUi(false);
          toast.success(res.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
        } else {
          setIsLoading(false);
          toast.error(res.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }

  function deleteScheduleById() {
    setIsLoading(true);
    axios
      .delete(
        `${BaseUrl.baseurl}/email-marketing/automation/delete-schedule/${
          userDetails && userDetails.details._id
        }/${selectedSchedule._id}`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          getShceduleData();
          setIsLoading(false);
          selectedScheduleSetterFun("");
          toast.success(res.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          setOpenDeleteModal(false);
        } else {
          setIsLoading(false);
          toast.error(res.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          setOpenDeleteModal(false);
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }

  function updateSchedule() {
    setIsLoading(true);
    const modifiedData = daylistArr.map((item) => ({
      ...item,
      StartHour: parseInt(convertTo24HourFormat(item.StartHour)),
      EndHour: parseInt(convertTo24HourFormat(item.EndHour)),
    }));
    let schedData = {
      Name: shceduleName,
      TimeZone: countryTimeSchedule,
      Day: modifiedData,
    };
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/automation/update-schedule-days/${
          userDetails && userDetails.details._id
        }/${selectedSchedule._id}`,
        { data: JSON.stringify(schedData) },
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          getShceduleData();
          setIsLoading(false);
          setDefaultUi(false);
          toast.success(res.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
        } else {
          setIsLoading(false);
          toast.error(res.data.message, {
            autoClose: true,
            position: "top-right",
            duration: 3000,
          });
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }

  function getShceduleData() {
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/automation/get-all-schedule/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          const updatedScheduleData = res.data?.details?.map((schedule) => ({
            ...schedule,
            checked:
              selectedScheduleData !== ""
                ? schedule._id === selectedScheduleData._id
                : false,
          }));
          setScheduleData(updatedScheduleData);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          if (res.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }

  const handleCheckboxChange = (index) => {
    const updatedScheduleData = scheduleData.map((schedule, i) => ({
      ...schedule,
      checked: i === index ? !schedule.checked : false,
    }));
    setScheduleData(updatedScheduleData);
    if (updatedScheduleData[index].checked) {
      setSelectedSchedule(updatedScheduleData[index]);
    }
  };

  useEffect(() => {
    getShceduleData();
  }, []);

  const createShceduleUi = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <div
          style={{
            padding: "10px 16px",
            borderBottom: "1px solid #DDD",
            flexShrink: 0,
          }}
        >
          <p
            style={{
              fontFamily: "Source Sans 3",
              fontSize: "20px",
              fontStyle: "normal",
              fontWeight: 700,
              color: "#4B4B4B",
            }}
          >
            Create New schedule
          </p>
        </div>
        <div
          style={{
            flexGrow: 1,
            overflowY: "scroll",
            backgroundColor: "Background",
            padding: "12px 16px",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              padding: "12px",
              borderRadius: "12px",
              // boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
            }}
          >
            <label
              htmlFor="schedule"
              style={{
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 400,
                color: "#4B4B4B",
              }}
            >
              Schedule name
            </label>
            <input
              value={shceduleName}
              onChange={(e) => {
                setScheduleName(e.target.value);
              }}
              id="schedule"
              type="text"
              autoComplete="off"
              style={{
                border: "1px solid #1C485F",
                padding: "12px 12px",
                backgroundColor: "#FAFAFA",
                outline: "none",
                borderRadius: "4px",
              }}
              placeholder="Ex:New schedule"
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              padding: "12px",
              borderRadius: "12px",
              // boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
            }}
          >
            <p
              style={{
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 400,
                color: "#4B4B4B",
              }}
            >
              Country time
            </p>
            <Autocomplete
              displayEmpty
              variant="standard"
              value={countryTimeSchedule}
              disableUnderline
              options={timezoneArr}
              onChange={handleChange9}
              sx={{
                backgroundColor: "#FAFAFA",

                borderRadius: "4px",
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 400,
                color: "#4B4B4B",
                maxHeight: 160,
                overflowY: "auto",
                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "#eee",
                  },
              }}
              renderInput={(params) => (
                <TextField
                  placeholder="Choose country time"
                  sx={{
                    outline: "none",
                  }}
                  {...params}
                />
              )}
              inputProps={{ "aria-label": "Without label" }}
              MenuProps={{
                PaperProps: {
                  style: {
                    height: 160,
                    overflowY: "auto",
                  },
                },
              }}
            ></Autocomplete>
            <div>
              <div className="shceduledayfrombox">
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3,1fr)",
                    gap: "16px",
                    marginTop: "13px",
                  }}
                >
                  <div
                    style={{
                      fontFamily: "Source Sans 3",
                      fontSize: "14px",
                      fontStyle: "normal",
                      color: "#4B4B4B",
                      fontWeight: 700,
                      width: "155px",
                    }}
                  >
                    Days
                  </div>
                  <div
                    style={{
                      fontFamily: "Source Sans 3",
                      fontSize: "14px",
                      fontStyle: "normal",
                      color: "#4B4B4B",
                      fontWeight: 700,
                    }}
                  >
                    From
                  </div>
                  <div
                    style={{
                      fontFamily: "Source Sans 3",
                      fontSize: "14px",
                      fontStyle: "normal",
                      color: "#4B4B4B",
                      fontWeight: 700,
                    }}
                  >
                    To
                  </div>
                </div>
                <div className="weeksdaysbox">
                  {daylistArr.map((val, idx) => {
                    return (
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(3,1fr)",
                          gap: "16px",
                        }}
                      >
                        <FormControlLabel
                          sx={{ width: "150px" }}
                          value={val.Day}
                          control={
                            <Checkbox
                              checked={val.Active}
                              style={{
                                color: "#1C485F",
                              }}
                            />
                          }
                          label={val.Day}
                          onClick={(e) => {
                            val.Active = !val.Active;
                            setDayListArr([...daylistArr]);
                          }}
                        />
                        <FormControl size="medium" sx={{ width: "100%" }}>
                          <Select
                            displayEmpty
                            variant="standard"
                            disableUnderline
                            value={val.StartHour}
                            onChange={(e) => {
                              val.StartHour = e.target.value;
                              setDayListArr([...daylistArr]);
                            }}
                            sx={{
                              outline: "none",
                              backgroundColor: "#FAFAFA",
                              padding: "6px 0px 6px 6px",
                              opacity: !val.Active && "0.3",
                              pointerEvents: !val.Active && "none",
                              border: "1px solid #1c485f",
                              borderRadius: "4px",
                              fontFamily: "Source Sans 3",
                              fontSize: "14px",
                              fontStyle: "normal",
                              fontWeight: 400,
                              color: "#4B4B4B",
                            }}
                            renderValue={(selected) => {
                              if (selected.length === 0) {
                                return (
                                  <em
                                    style={{
                                      fontStyle: "normal",
                                      fontSize: "14px",
                                      color: "#888888",
                                    }}
                                  >
                                    Choose country time
                                  </em>
                                );
                              }
                              return selected;
                            }}
                            inputProps={{ "aria-label": "Without label" }}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 160,
                                },
                              },
                            }}
                          >
                            {timeList.map((name, index) => (
                              <MenuItem
                                disableRipple
                                disableTouchRipple
                                key={index}
                                value={name}
                                sx={{
                                  borderBottom:
                                    timezoneArr.length !== index + 1 &&
                                    "1px solid #DDD",
                                  fontFamily: "Source Sans 3",
                                  fontSize: "14px",
                                  fontWeight: 400,
                                  fontStyle: "normal",
                                  color: "#838383",
                                  padding: "12px",
                                }}
                              >
                                {name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <FormControl size="medium" sx={{ width: "100%" }}>
                          <Select
                            displayEmpty
                            variant="standard"
                            disableUnderline
                            value={val.EndHour}
                            onChange={(e) => {
                              val.EndHour = e.target.value;
                              setDayListArr([...daylistArr]);
                            }}
                            sx={{
                              outline: "none",
                              backgroundColor: "#FAFAFA",
                              opacity: !val.Active && "0.3",
                              pointerEvents: !val.Active && "none",
                              border: "1px solid #1c485f",
                              padding: "6px 0px 6px 6px",
                              borderRadius: "4px",
                              fontFamily: "Source Sans 3",
                              fontSize: "14px",
                              fontStyle: "normal",
                              fontWeight: 400,
                              color: "#4B4B4B",
                            }}
                            renderValue={(selected) => {
                              if (selected.length === 0) {
                                return (
                                  <em
                                    style={{
                                      fontStyle: "normal",
                                      fontSize: "14px",
                                      color: "#888888",
                                    }}
                                  >
                                    Choose country time
                                  </em>
                                );
                              }
                              return selected;
                            }}
                            inputProps={{ "aria-label": "Without label" }}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 160,
                                },
                              },
                            }}
                          >
                            {timeList.map((name, index) => (
                              <MenuItem
                                disableRipple
                                disableTouchRipple
                                key={index}
                                value={name}
                                sx={{
                                  borderBottom:
                                    timezoneArr.length !== index + 1 &&
                                    "1px solid #DDD",
                                  fontFamily: "Source Sans 3",
                                  fontSize: "14px",
                                  fontWeight: 400,
                                  fontStyle: "normal",
                                  color: "#838383",
                                  padding: "12px",
                                }}
                              >
                                {name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            gap: "10px",
            borderTop: "1px solid #DDD",
            flexShrink: 0,
            padding: "10px 16px",
          }}
        >
          <button
            onClick={() => {
              setDefaultUi(false);
              // setterFun(false);
              setScheduleName("");
              setCountryTimeSchdule(null);
            }}
            style={{
              fontFamily: "Source Sans 3",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
              color: "#1C485F",
              backgroundColor: "transparent",
              border: "1px solid #1C485F",
              borderRadius: "6px",
              padding: "6px 12px",
              cursor: "pointer",
              outline: "none",
            }}
          >
            Back
          </button>
          <div
            style={{
              display: "flex",
              gap: "10px",
            }}
          >
            <button
              onClick={() => {
                setDefaultUi(false);
                setterFun(false);
                setScheduleName("");
                setCountryTimeSchdule(null);
              }}
              style={{
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 400,
                color: "#1C485F",
                backgroundColor: "transparent",
                border: "1px solid #1C485F",
                borderRadius: "6px",
                padding: "6px 12px",
                cursor: "pointer",
                outline: "none",
              }}
            >
              Cancel
            </button>
            <button
              onClick={() => {
                if (updateStatus) {
                  updateSchedule();
                } else {
                  createSchedule();
                  setScheduleName("");
                  setCountryTimeSchdule(null);
                }
              }}
              disabled={countryTimeSchedule === null || shceduleName === ""}
              style={{
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 400,
                color: "#FFF",
                outline: "none",
                borderRadius: "6px",
                padding: "6px 20px",
                outline: "none",
              }}
              className="bg-primary"
            >
              {updateStatus ? "Update" : "Save"}
            </button>
          </div>
        </div>
      </div>
    );
  };
  const convertTo24HourFormat2 = (time) => {
    const [hour, period] = time.split(/[: ]/); // Split by `:` and space
    let hour24 = parseInt(hour, 10);
  
    if (period === "PM" && hour24 !== 12) {
      hour24 += 12;
    } else if (period === "AM" && hour24 === 12) {
      hour24 = 0;
    }
  
    return hour24;
  };
  const is12HourFormat = (time) => {
    return typeof time === "string" && /^\d{1,2}:\d{2} (AM|PM)$/.test(time);
  };
  const listOfScheduleCardsUi = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <div
          className="emailboxx"
          style={{
            fontFamily: "Source Sans 3",
            fontSize: "20px",
            fontStyle: "normal",
            fontWeight: 700,
            color: "#4B4B4B",
            flexShrink: 0,
          }}
        >
          Choose Schedule
        </div>
        <div
          style={{
            flexGrow: 1,
            overflowY: "scroll",
            backgroundColor: "Background",
            display: "flex",
            flexDirection: "column",
            padding: "16px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {scheduleData.length > 0 ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                {scheduleData.map((val, index) => {
                  return (
                    <div
                      className="scheduleboxdrawer"
                      style={{
                        backgroundColor: val.checked && "#D1DFE9",
                        border: val.checked
                          ? "1px solid var(--color-success, #53D86A)"
                          : "1px solid #DDD",
                      }}
                    >
                      <div className="shcedulelistbox">
                        {" "}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Checkbox
                            checked={val.checked}
                            id={`schedule-status-${val.Name}`}
                            onChange={() => handleCheckboxChange(index)}
                            disableRipple
                            disableTouchRipple
                            sx={{
                              color: "#1C485F",
                              "&.Mui-checked": {
                                color: "#1C485F",
                              },
                            }}
                          />
                          <label
                            htmlFor={`schedule-status-${val.Name}`}
                            className="cursor-pointer"
                          >
                            {val.Name}
                          </label>
                        </div>
                        <div className="shcedulerightsideicom">
                          <svg
                            onClick={() => {
                              setOpenDeleteModal(true);
                              setSelectedSchedule(val);
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="21"
                            viewBox="0 0 20 21"
                            fill="none"
                          >
                            <path
                              d="M17.5 5.94401C14.725 5.66901 11.9333 5.52734 9.15 5.52734C7.5 5.52734 5.85 5.61068 4.2 5.77734L2.5 5.94401"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M7.08594 5.10232L7.26927 4.01065C7.4026 3.21899 7.5026 2.62732 8.91094 2.62732H11.0943C12.5026 2.62732 12.6109 3.25232 12.7359 4.01899L12.9193 5.10232"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M15.7057 8.57739L15.1641 16.9691C15.0724 18.2774 14.9974 19.2941 12.6724 19.2941H7.3224C4.9974 19.2941 4.9224 18.2774 4.83073 16.9691L4.28906 8.57739"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M8.60938 14.7107H11.3844"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M7.91406 11.3773H12.0807"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <svg
                            onClick={() => {
                              handleCheckboxChange(index)
                              setDefaultUi(true);
                              setUpdateStatus(true);
                              setNewSchedule(true);
                              setScheduleName(val.Name);
                              setSelectedSchedule(val);
                              setCountryTimeSchdule(val.TimeZone);
                              let vikki = val.Day;
                              vikki.map((value) => {
                                value.EndHour = convertTo12HourFormat(
                                  parseInt(value.EndHour)
                                );
                                value.StartHour = convertTo12HourFormat(
                                  parseInt(value.StartHour)
                                );
                                delete value._id;
                              });
                              setDayListArr(vikki);
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="21"
                            viewBox="0 0 20 21"
                            fill="none"
                          >
                            <path
                              d="M9.16406 2.62732H7.4974C3.33073 2.62732 1.66406 4.29399 1.66406 8.46065V13.4607C1.66406 17.6273 3.33073 19.294 7.4974 19.294H12.4974C16.6641 19.294 18.3307 17.6273 18.3307 13.4607V11.794"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M13.3675 3.47733L6.80088 10.044C6.55088 10.294 6.30088 10.7857 6.25088 11.144L5.89254 13.6523C5.75921 14.5607 6.40088 15.194 7.30921 15.069L9.81754 14.7107C10.1675 14.6607 10.6592 14.4107 10.9175 14.1607L17.4842 7.59399C18.6175 6.46066 19.1509 5.14399 17.4842 3.47733C15.8175 1.81066 14.5009 2.34399 13.3675 3.47733Z"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M12.4219 4.41907C12.9802 6.41073 14.5385 7.96907 16.5385 8.53573"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                      <div
                        className="shedulednametext"
                        style={{
                          border: "1px solid #1C485F",
                        }}
                      >
                        {val.TimeZone}
                      </div>
                      <div className="weeknameslist">
                        {val.Day.map((value) => {
                          return (
                            <div className="nameandticked">
                              {" "}
                              {!value.Active ? (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="13"
                                  height="13"
                                  viewBox="0 0 24 25"
                                  fill="none"
                                >
                                  <rect
                                    x="0.5"
                                    y="1.46069"
                                    width="23"
                                    height="23"
                                    rx="3.5"
                                    fill="white"
                                    stroke="#1C485F"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  width="13"
                                  height="13"
                                  viewBox="0 0 25 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <rect
                                    x="0.25"
                                    width="24"
                                    height="24"
                                    rx="4"
                                    fill="#1C485F"
                                  />
                                  <path
                                    d="M19.1069 6.85693L9.67829 16.2855L5.39258 11.9998"
                                    stroke="white"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              )}{" "}
                              {value.Day}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}
                <button
                  className=" bg-primary text-white font-normal text-base rounded-md"
                  onClick={() => {
                    setDefaultUi(true);
                  }}
                  style={{
                    alignSelf: "flex-start",
                    padding: "12px 16px",
                    marginTop: "14px",
                  }}
                >
                  Create New Schedule
                </button>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={nodata}
                  alt="no-data"
                  style={{ height: "250px", width: "250px" }}
                  loading="lazy"
                />
                <p className="nocampaigncreated">No schedules yet</p>
                <button
                  className=" bg-primary text-white font-normal text-base rounded-md"
                  onClick={() => {
                    setDefaultUi(true);
                  }}
                  style={{
                    padding: "12px 16px",
                    marginTop: "14px",
                  }}
                >
                  Create New Schedule
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="schedulefooter">
          <div
            className="cancelconfirmbuttonbox"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <button
              onClick={() => {
                setterFun(false);
              }}
              className="cancelbyutnschedule"
            >
              Cancel
            </button>
            {console.log("jabbesha", selectedSchedule)}
            <button
              disabled={selectedSchedule === null}

              className="bg-primary text-white rounded-md"
              style={{
                opacity: selectedSchedule === null && "0.5",
                cursor: selectedSchedule === null && "not-allowed",
                padding: "10px",
                outline: "none",
                
              }}
              onClick={() => {
                const updatedSchedule = {
                  ...selectedSchedule, 
                  Day: selectedSchedule.Day.map((item) => ({
                    ...item,
                    StartHour: is12HourFormat(item.StartHour)
                    ? parseInt(convertTo24HourFormat(item.StartHour))
                    : item.StartHour,
                    EndHour: is12HourFormat(item.EndHour)
                    ? parseInt(convertTo24HourFormat(item.EndHour))
                    : item.EndHour,
                  })),
                };
                
                console.log("Updated Schedule:", updatedSchedule);
                selectedScheduleSetterFun(updatedSchedule);
                setterFun(false);
                setTimeout(() => {
                  // setSelectedSchedule("");
                  setScheduleName("");
                  setCountryTimeSchdule(null);
                }, 3000);
              }}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Drawer
        placement={"right"}
        open={openCreateScheduleDrawer}
        onClose={() => {
          setterFun(false);
          setScheduleName("");
          setCountryTimeSchdule(null);
          if (!defaultUi) {
            setSelectedSchedule("");
          } else {
            setDefaultUi(false);
          }
        }}
        size="sm"
      >
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "160px 0px",
            }}
          >
            <Loader />
          </div>
        ) : !defaultUi ? (
          listOfScheduleCardsUi()
        ) : (
          createShceduleUi()
        )}
      </Drawer>
      <Modal
        open={openDeleteModal}
        onClose={() => {
          setOpenDeleteModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="modalPopupDelete">
          <div className="modaltext">Confirm Delete</div>
          <div className="modalsubtext">
            Are you sure you want to delete this schedule?
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              width: "100%",
            }}
          >
            <div
              className="cancelbuttonmodal"
              onClick={() => {
                setOpenDeleteModal(false);
              }}
            >
              Cancel
            </div>
            <div
              className="continuebuttonmodal"
              onClick={() => {
                deleteScheduleById();
              }}
            >
              Continue
            </div>
          </div>
        </div>
      </Modal>
      <ToastContainer />
    </>
  );
};

export default CreateScheduleDrawer;
